import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomCheckoutGuard } from '../../guards/custom-checkout.guard';
import { CheckoutOrchestratorComponent } from './checkout-orchestrator.component';

@NgModule({
  imports: [CommonModule],
  providers: [
    provideConfig({
      cmsComponents: {
        CheckoutOrchestrator: {
          component: CheckoutOrchestratorComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard, CustomCheckoutGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CheckoutOrchestratorComponent],
  exports: [CheckoutOrchestratorComponent]
})
export class CustomCheckoutOrchestratorModule { }
